import {
  GET_NOTIFICATIONS_FAILURE,
  GET_NOTIFICATIONS_REQUEST,
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATION_FAILURE,
  GET_NOTIFICATION_REQUEST,
  GET_NOTIFICATION_SUCCESS,
  POST_MAKE_READ_FAILURE,
  POST_MAKE_READ_REQUEST,
  POST_MAKE_READ_SUCCESS,
  GET_ALL_NOTIFICATIONS_REQUEST,
  GET_ALL_NOTIFICATIONS_SUCCESS,
  GET_ALL_NOTIFICATIONS_FAILURE,
  POST_MAKE_UNREAD_FAILURE,
  POST_MAKE_UNREAD_REQUEST,
  POST_MAKE_UNREAD_SUCCESS,
  GET_IMPORTANCE_NOTIFICATIONS_REQUEST,
  GET_IMPORTANCE_NOTIFICATIONS_SUCCESS,
  GET_IMPORTANCE_NOTIFICATIONS_FAILURE,
} from '../actions/notifications'

export const getNotification = (
  state = {
    isFetching: false,
    user: null,
    errorMessage: '',
  },
  action
) => {
  switch (action.type) {
    case GET_NOTIFICATION_REQUEST:
      return {
        ...state,
        results: null,
        isFetching: true,
        errorMessage: '',
      }
    case GET_NOTIFICATION_SUCCESS:
      return {
        ...state,
        errorMessage: '',
        isFetching: false,
        results: action.response,
      }
    case GET_NOTIFICATION_FAILURE:
      return {
        ...state,
        errors: null,
        results: null,
        isFetching: false,
        errorMessage: action.error,
      }
    default:
      return state
  }
}

export const getNotifications = (
  state = {
    isFetching: false,
    user: null,
    errorMessage: null,
  },
  action
) => {
  switch (action.type) {
    case GET_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        results: null,
        isFetching: true,
        errorMessage: null,
      }
    case GET_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        isFetching: false,
        results: action.response,
      }
    case GET_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        errors: null,
        results: null,
        isFetching: false,
        errorMessage: action.error,
      }
    default:
      return state
  }
}

export const getImportanceNotifications = (
  state = {
    isFetching: false,
    user: null,
    errorMessage: null,
  },
  action
) => {
  switch (action.type) {
    case GET_IMPORTANCE_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        results: null,
        isFetching: true,
        errorMessage: null,
      }
    case GET_IMPORTANCE_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        isFetching: false,
        results: action.response,
      }
    case GET_IMPORTANCE_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        errors: null,
        results: null,
        isFetching: false,
        errorMessage: action.error,
      }
    default:
      return state
  }
}

export const getAllNotifications = (
  state = {
    isFetching: false,
    user: null,
    errorMessage: null,
  },
  action
) => {
  switch (action.type) {
    case GET_ALL_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        results: null,
        isFetching: true,
        errorMessage: null,
      }
    case GET_ALL_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        isFetching: false,
        results: action.response,
      }
    case GET_ALL_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        errors: null,
        results: null,
        isFetching: false,
        errorMessage: action.error,
      }
    default:
      return state
  }
}

export const makeReadNotification = (
  state = {
    isFetching: false,
    errorMessage: null,
  },
  action
) => {
  switch (action.type) {
    case POST_MAKE_READ_REQUEST:
      return {
        ...state,
        results: null,
        isFetching: true,
        errorMessage: null,
      }
    case POST_MAKE_READ_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        isFetching: false,
        results: action.response,
      }
    case POST_MAKE_READ_FAILURE:
      return {
        ...state,
        errors: null,
        results: null,
        isFetching: false,
        errorMessage: action.error,
      }
    default:
      return state
  }
}

export const makeUnreadNotification = (
  state = {
    isFetching: false,
    errorMessage: null,
  },
  action
) => {
  switch (action.type) {
    case POST_MAKE_UNREAD_REQUEST:
      return {
        ...state,
        results: null,
        isFetching: true,
        errorMessage: null,
      }
    case POST_MAKE_UNREAD_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        isFetching: false,
        results: action.response,
      }
    case POST_MAKE_UNREAD_FAILURE:
      return {
        ...state,
        errors: null,
        results: null,
        isFetching: false,
        errorMessage: action.error,
      }
    default:
      return state
  }
}
